import { Select, SelectProps } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import { ReactNode } from 'react';
import styles from './index.module.scss';

type MultiSelectValueType = string[] | number[];
type SelectValueType = string | number | null;
type ChangedValueType = MultiSelectValueType | SelectValueType;

export const CommonSelect = (
  props: SelectProps & {
    after?: ReactNode;
    maxCount?: number;
    prefix?: string;
    name?: string;
    sortOption?: boolean;
  }
) => {
  const { maxCount, prefix, onChange } = props;

  const innerOnChange = (
    value: ChangedValueType,
    option: DefaultOptionType | DefaultOptionType[]
  ) => {
    if (value instanceof Array && maxCount && value.length > maxCount) {
      return;
    }
    onChange?.(value, option);
  };

  const defaultFilter = (inputValue = '', option?: DefaultOptionType) => {
    return (
      String(option?.label)
        .toLowerCase()
        .includes(String(inputValue).toLowerCase()) ||
      String(option?.value)
        .toLowerCase()
        .includes(String(inputValue).toLowerCase())
    );
  };

  const getOptions = () => {
    const { options = [], value, sortOption } = props;
    if (!sortOption) {
      return options;
    }
    if (value instanceof Array) {
      return [...options].sort((a, b) => {
        const aIndex = value.indexOf(a.value);
        const bIndex = value.indexOf(b.value);
        if (aIndex === -1 && bIndex === -1) {
          return -1;
        }

        if (aIndex >= 0 && bIndex === -1) {
          return -1;
        }

        if (aIndex === -1 && bIndex >= 0) {
          return 1;
        }

        if (bIndex < aIndex) {
          return 1;
        }

        return -1;
      });
    }

    return [...options].sort((a, b) => {
      if (value === b.value && value !== a.value) {
        return 1;
      }
      return -1;
    });
  };

  return (
    <>
      <Select
        {...props}
        options={getOptions()}
        className={`${styles.select} ${
          prefix ? styles.hasPrefix : ''
        } common-select ${props.className || ''}`}
        onChange={innerOnChange}
        value={props.value}
        filterOption={props.filterOption || defaultFilter}
        virtual={props.virtual || false}
        style={{
          // @ts-ignore
          '--input-label': `"${prefix}"` || '',
          ...(props.style || {}),
        }}
      >
        {props.children}
      </Select>
      {!!props.after && <span className={styles.after}>{props.after}</span>}
    </>
  );
};
